import { useSuspenseQuery } from '@apollo/client/react';

import { findManyCategoryQuery } from '~/shared/graphql-queries/categories';

export const useFindManyCategoryQuery = ({ limit, filter }, options) => {
  const useQueryProps = useSuspenseQuery(findManyCategoryQuery, {
    variables: {
      limit,
      filter,
    },
    notifyOnNetworkStatusChange: true,
    ...options,
  });
  const { loading, error, data } = useQueryProps;

  return {
    loading,
    error,
    data,
  };
};
